var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h6',{staticClass:"d-block mb-4"},[_vm._v(_vm._s(_vm.$t('ACADEMICO.PRECOS')))]),_c('b-table',{attrs:{"head-variant":"light","empty-text":_vm.$t('GERAL.NENHUM_REGISTRO'),"items":_vm.itens,"fields":_vm.campos,"responsive":"","show-empty":"","striped":"","hover":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }